/**
 * Central tenant stamping for content writes (Phase D2).
 * All create paths must use withTenantScope — never set tenantId in UI.
 */

export function withTenantScope(activeTenantId, payload) {
  if (!activeTenantId || String(activeTenantId).trim() === '') {
    throw new Error('[contentWrite] activeTenantId is required for content writes');
  }

  return {
    ...payload,
    tenantId: String(activeTenantId),
  };
}
